import { Button, strIsNullOrEmpty, MuiAlert } from '@fox/atoms';
import { FlexColumnSpaced } from '@fox/layout';
import { Form, Formik, FormikHelpers as FormikActions } from 'formik';
import { useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { MembershipFormTemplateProps } from './contracts';
import { FORM_FIELD_COMPONENT_MAP } from './fields';

export function MemberShipFormTemplate<T>({
	submitFunction,
	validationSchema,
	initialValues,
	fields,
	contentId,
	recaptcha,
	submitButtonText,
	onSuccessFullSubmit,
	successMessage
}: MembershipFormTemplateProps<T>) {
	const { executeRecaptcha } = useGoogleReCaptcha();
	const [submitError, setSubmitError] = useState<string>('');
	const [submittedSuccessfully, setSubmittedSuccessFully] = useState<boolean>(false);

	const handleResponse = async (resp: Response, actions: FormikActions<T>) => {
		if (!resp.ok) {
			setSubmitError('Error submitting form, please contact support');
			actions.setSubmitting(false);
		} else {
			const jsonRes = await resp.json();
			if (jsonRes.success === false) {
				setSubmitError(`${jsonRes?.message ?? ''}`);
				actions.setSubmitting(false);
			} else {
				setSubmittedSuccessFully(true);
				onSuccessFullSubmit?.();
			}
		}
	};

	const submit = async (values: T, actions: FormikActions<T>) => {
		//const rcToken = getRcTokenAsync(recaptcha, executeRecaptcha);
		//const body = { ...values, RcToken: await tokenFailable(rcToken), contentId };
		try {
			setSubmitError('');
			setSubmittedSuccessFully(false);
			await submitFunction(values).then(resp => {
				handleResponse(resp, actions);
			});
		} catch (e) {
			setSubmitError(e.message);
			actions.setSubmitting(false);
		}
	};
	if (submittedSuccessfully)
		return successMessage ? <>{successMessage}</> : <MuiAlert severity="success">{'Your details have been accepted'}</MuiAlert>;

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={submit}>
			{({ isSubmitting, touched, errors, setFieldValue, values }) => {
				return (
					<Form>
						<FlexColumnSpaced
							style={{
								margin: '0 auto',
								paddingBottom: '1rem'
							}}
						>
							{fields.map(field => {
								const Component = FORM_FIELD_COMPONENT_MAP[field.fieldType];
								return (
									<Component
										key={field.name}
										field={field}
										helperText={touched[field.name] && errors[field.name]}
										error={touched[field.name] && !strIsNullOrEmpty(errors[field.name])}
										setFieldValue={setFieldValue}
										value={values[field.name]}
									/>
								);
							})}
							<Button type="submit" size="large" variant="primary" disabled={isSubmitting || submittedSuccessfully}>
								{submitButtonText}
							</Button>
							{submitError ? <MuiAlert severity="error">{submitError}</MuiAlert> : null}
						</FlexColumnSpaced>
					</Form>
				);
			}}
		</Formik>
	);
}
